import script from "./SecondView.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondView.vue?vue&type=script&setup=true&lang=js"

import "./SecondView.vue?vue&type=style&index=0&id=11f3deac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f3deac"]])

export default __exports__